import { render, staticRenderFns } from "./tag_cloud.vue?vue&type=template&id=55e1d8ab&"
import script from "./tag_cloud.vue?vue&type=script&lang=js&"
export * from "./tag_cloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports